import React from "react";
import { useNavigate } from "react-router-dom";
const StepIndicatorMethod = ({ stepNumber, lineWidth }) => {
    const navigate = useNavigate();
    const handleBackClick = () => {
        navigate('/auditList')
    }
    return (
        <div
            className="step-indicator-method"
            style={{
                display: "flex",
                alignItems: "center",
                position: "relative",
                width: "100%",
            }}
        >
            <div
                style={{
                    position: "absolute",
                    left: 0,
                }}
            >
                    {/* <button
                        onClick={handleBackClick}
                        style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "28px",
                            color: "black",
                            padding: "0",
                            marginLeft: "10px",
                            marginTop: "80px"
                        }}
                    >
                        <img
                            src={`${process.env.PUBLIC_URL}/backButton.png`}
                            alt="Back"
                            style={{
                                width: "26px", 
                                height: "24px", 
                            }}
                        />
                    </button> */}
            </div>
            <div
                style={{
                    width: "27px",
                    height: "27px",
                    borderRadius: "50%",
                    backgroundColor: "#FF0083",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontSize: "0.8rem",
                    margin: "0 auto", 
                    zIndex: 1,
                }}
            >
                {stepNumber}
            </div>

            <div
                style={{
                    width: lineWidth, // Use the passed width
                    height: "1px",
                    backgroundColor: "grey",
                    position: "absolute",
                    left: "50%", // Start the line from the middle of the circle
                    top: "50%", // Center the line vertically with the circle
                    transform: "translateX(15px)", // Offset the line to create space from the circle
                    marginLeft: "5px", // Adds extra space between the circle and line
                }}
            />
        </div>
    );
};

export default StepIndicatorMethod;
